import * as React from "react";

function SvgComponent(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16.001" width="1em" height="1em" {...props}><g fill="#474747"><path d="M7.969 0C4.663 0 1.945 3.008 2 5.719c.062 3.022.934 4.695 1.125 5.281h1.4c-1.16-2.292-1.048-5.156-1.048-5.156 0-2.373 2.007-4.313 4.493-4.313 2.485 0 4.5 1.92 4.492 4.375-.024 1.674-.172 2.284-1.006 4.813h1.571c.225-.645.974-2.066.974-4.906C14 2.983 11.274 0 7.969 0z" /><path d="M12.6 7.059c-.84-.234-1.766.368-2.079 1.351l-.426 1.343c-.312.983.112 1.963.951 2.197.84.234 1.766-.368 2.078-1.351l.426-1.343c.313-.983-.112-1.963-.95-2.197zm-9.148.001c.84-.235 1.766.368 2.078 1.35l.427 1.343c.312.983-.112 1.963-.951 2.197-.84.235-1.766-.368-2.078-1.35L2.5 9.255c-.312-.983.112-1.963.951-2.197z" /><path d="M9.003 13h.016c.55 0 .992.447.992 1 0 .555-.442 1-.992 1h-.016a.994.994 0 01-.992-1c0-.553.443-1 .992-1z" style={{
        marker: "none"
      }} color="#000" overflow="visible" /><path d="M12.695 9.405a.5.5 0 00-.149.97l1.452.536-.018 1.746c-.005.532-.146.858-.322 1.053-.177.195-.404.29-.72.29H9.014a.5.5 0 100 1h3.922c.548 0 1.087-.203 1.463-.618.376-.415.574-1.007.58-1.717l.024-2.45-2.112-.777a.5.5 0 00-.197-.033z" style={{
        lineHeight: "normal",
        fontVariantLigatures: "normal",
        fontVariantPosition: "normal",
        fontVariantCaps: "normal",
        fontVariantNumeric: "normal",
        fontVariantAlternates: "normal",
        fontFeatureSettings: "normal",
        textIndent: 0,
        textAlign: "start",
        textDecorationLine: "none",
        textDecorationStyle: "solid",
        textDecorationColor: "#000",
        textTransform: "none",
        textOrientation: "mixed",
        shapePadding: 0,
        isolation: "auto",
        mixBlendMode: "normal"
      }} color="#000" fontWeight={400} fontFamily="sans-serif" overflow="visible" /></g></svg>;
}

export default SvgComponent;